import type { Nullish, ProductKind } from '@iheartjane/types';

export const SEO_PAGE_TYPES = [
  'category',
  'customRow',
  'deal',
  'featured',
  'pdp',
  'shopAll',
] as const;

export type SEOPageType = (typeof SEO_PAGE_TYPES)[number];

export type CustomSEOProps = SEOPageType | `onPage.${ProductKind}`;

export interface CustomSEOPage {
  description?: Nullish<string>;
  title?: Nullish<string>;
}

type SEOMetadata = Partial<Record<SEOPageType, CustomSEOPage>>;
export type CustomSEOOnPage = Partial<Record<ProductKind, CustomSEOPage>>;

export type CustomSEO = SEOMetadata & {
  onPage?: CustomSEOOnPage;
};
